import { Program } from '@percent/admin-dashboard/api/actions/grantProgram/grantProgram.types'

export type ProgramHeaderProps = {
  activeTab: ProgramTab
  setActiveTab: (tab: ProgramTab) => void
  program: Program
  onProgramAction?: () => void
}

export enum ProgramTab {
  OVERVIEW = 'overview',
  STATE_MACHINE = 'state_machine',
  CANDIDATES = 'candidates',
  TASK_TEMPLATES = 'task_templates'
}

export type ProgramTabs = {
  label: string
  key: ProgramTab
}[]
